import { atom } from "recoil";
import { t } from "i18next";
import type { PlannedRoute } from '@app/shared/models/tour.type';

export const atom_showModalContent = atom<boolean>({
  key: "ShowModal",
  default: false
});

export const atom_modalType = atom<string | null>({
  key: "ModalType",
  default: null
});

export const atom_downloadProgressBar = atom<number>({
  key: "Progress",
  default: 0
});

export const atom_showClustersAndMarkers = atom<boolean>({
  key: 'showClustersAndMarkers',
  default: true,
});

export interface NavigationHelperState {
  anchorEl: HTMLElement | null;
  offset?: { top?: number; left?: number; x?: number };
  usePopover?: boolean;
  reverseOrder?: boolean;
}

export const atom_navigationHelperState = atom<NavigationHelperState>({
  key: 'atom_navigationHelperState',
  default: {
    anchorEl: null,
    offset: undefined,
    usePopover: false,
  },
});

/** Natural width (px) of the first image in a small-stop popup, or null when unknown. */
export const atom_smallStopImageWidth = atom<number | null>({
  key: 'atom_smallStopImageWidth',
  default: null,
});

// ----- DISABLED FOR PROD — re-enable for next release -----
// Planned-route feature is hidden in production. Don't auto-restore from localStorage,
// otherwise users with a previously-saved plan would still see the green pill in MapFilters
// even though the entry points are commented out.
// const getStoredPlannedRoute = (): PlannedRoute | null => {
//   try {
//     const stored = localStorage.getItem('plannedRoute');
//     return stored ? JSON.parse(stored) : null;
//   } catch {
//     return null;
//   }
// };
// ----- /DISABLED FOR PROD -----

export const atom_plannedRoute = atom<PlannedRoute | null>({
  key: 'atom_plannedRoute',
  default: null, // DISABLED FOR PROD: was getStoredPlannedRoute()
});
